import  ComercialBox  from "./comercial/ComercialBox"
import "../../public/css/components/about/ComercialInfo.css"
function ComercialInfo(){
    return(
         <div className="comercial-container">
            <ComercialBox />
         </div>       
    )
}

export default ComercialInfo